<template>
    <div id="AddNewStock">
        <v-dialog persistent v-model="addStockDialog">
            <v-card class="pa-4">
                <v-card-title class="text-h5 font-weight-regular">
                    {{isSubtract?'Subtract':'Add'}} Stock<v-spacer/>
                    <div class="operation-div">
                        <span :style="isSubtract === false?'color:#4caf50':''" @click="isSubtract=false">ADD</span>
                        <v-switch inset v-model="isSubtract" class="operation-switch pl-4" color="red"/>
                        <span :style="isSubtract?'color:#f44336':''" @click="isSubtract=true">MINUS</span>
                    </div>
                </v-card-title>
                <v-card-text class="mt-6">
                    <v-form ref="form2">
                        <v-row>
                            <v-col class="pa-0 pl-2" v-if="productArr">
                                <label class="text-uppercase grey--text font-weight-bold">Select Branch</label>
                                <v-radio-group class="mt-3 " row outlined dense v-model="selectedWarehouse">
                                    <v-radio :label="warehouse.name" color="orange darken-4" v-for="(warehouse,index) in warehouses"
                                             :key="index" :value="warehouse.id"></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12">
                                <v-data-table :headers="headers" :items="orderItems" :items-per-page="-1" height="45vh" fixed-header hide-default-footer>
                                    <template v-slot:body="{ items }">
                                        <tbody>
                                        <tr v-for="(item,index) in items" :key="index" class="py-0">
                                            <td class="ellipsis product-content" :title="item.product.name">
                                                <v-avatar tile class="avatar mr-2" title="View Image">
                                                    <v-img v-if="item.product.Attachments.length" :src="imgWpx(item.product.Attachments[0].path, 200)" max-width="44" max-height="44">
                                                        <template v-slot:placeholder><v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                                                            <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                                        </template>
                                                    </v-img>
                                                    <v-icon v-else size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                                                </v-avatar>
                                                {{ item.product.name }}
                                            </td>
                                            <td>{{productStockByWarehouse(item.product)}}</td>
                                            <td><v-text-field type="number" outlined  v-model="item.quantity" class="qty-field mb-5"
                                                              :rules="isSubtract?[ v => v <= productStockByWarehouse(item.product) || 'Enter Qty ≤ '+ productStockByWarehouse(item.product)]:[]"/></td>
                                            <td><v-icon title="Delete Item" class="delete-item-icon" @click="deleteProduct(index)" :disabled="disableAddProduct">mdi-trash-can-outline</v-icon></td>
                                        </tr>
                                        <tr v-show="!disableAddProduct">
                                            <td>
                                                <v-autocomplete :items="productArr" item-text="name" item-value="id" return-object v-model="productForm.product"
                                                                style="width: 250px" placeholder="Product" outlined dense class="pt-5" ref="product-field">
                                                    <template v-slot:item="data">
                                                        <v-list-item-avatar><img :src="imgWpx(data.item.Attachments[0].path, 200)" v-if="data.item.Attachments.length"></v-list-item-avatar>
                                                        <v-list-item-content><v-list-item-title v-html="data.item.name"/></v-list-item-content>
                                                    </template>
                                                </v-autocomplete>
                                            </td>
                                            <td>{{productStockByWarehouse(productForm.product)}}</td>
                                            <td><v-text-field type="number" outlined  v-model="productForm.quantity" class="qty-field" ref="qty-field" :disabled="productForm.product===null"
                                                              :rules="isSubtract?[ v => v <= productStockByWarehouse(productForm.product) || 'Enter Qty ≤ '+ productStockByWarehouse(productForm.product)]:[]"/></td>
                                            <td class="pa-0">
                                                <v-btn small title="Add Item" class="green white--text mr-2 add-btn" @click="addProduct"
                                                       :disabled="($refs['qty-field']&&$refs['qty-field'].hasError)||productForm.product === null||productForm.quantity<1">ADD</v-btn>
                                                <v-btn small icon title="Revert" @click="revertProduct"><v-icon color="red">mdi-undo</v-icon></v-btn>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="mt-8">
                    <v-spacer></v-spacer>
                    <v-btn class="white elevation-0 text-capitalize" @click="cancel">Cancel</v-btn>
                    <v-btn class="white elevation-0 text-capitalize" @click="backToPreviousPopup" v-if="disableAddProduct">Back</v-btn>
                    <v-btn class="primary text-capitalize elevation-0 px-3" @click="handleSubmit" :disabled="orderItems.length===0">Add Stock</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <Snackbar :toaster="toaster"></Snackbar>
    </div>
</template>

<script>
    import {GET_ALL_PRODUCTS_IN_ADD_STOCK} from '../../graphql/queries/Products'
import {ADD_STOCK_ORDER} from '../../graphql/mutations/StockHistory'
import {SUBSCRIBE_ACTIVE_BRANCHES} from "../../graphql/subscriptions/Branches";
import Constants from "../../Constants/Constants";
import moment from 'moment';
import Snackbar from "../Common/Snackbar";
let user = JSON.parse(localStorage.user)
let productForm = {product: null, quantity:0}
let order = { type: Constants.StockImportType.StockAdd, createdBy:user.id, updatedBy:user.id}

export default {
    components: {Snackbar},
    ame: 'AddNewStock',                                          /* Purchase Request Product Stock */
    props: { addStockDialog: { type: [Boolean], default: false }, PRQStock: {type: Array, default:()=> []} },
    apollo: {
        $subscribe: {
            activeBranches: { query: SUBSCRIBE_ACTIVE_BRANCHES,
                result ({ data}) { this.warehouses = data.activeBranches }},
        },
    },
    data () {
        return {
            Constants: Constants,
            moment: moment,
            productForm: {...productForm},
            order: {...order},
            orderItems: [],
            warehouses: [],
            selectedWarehouse: Constants.Warehouses.Katargam,
            allProducts: [],
            productArr: [],
            headers: [{ text: 'PRODUCT'}, { text: 'CURRENT STOCK'}, { text: 'QUANTITY'}, { text: 'ACTION'}],
            isSubtract: false,
            toaster: {enable: false, color: 'green', message: ''}
        }
    },
    computed:{
      disableAddProduct(){
          return !!this.PRQStock.length;                /* Purchase Request Product Stock */
      }
    },
    methods: {
        productStockByWarehouse(product){
            return product?.WarehouseStock.filter(s => s.warehouseId === this.selectedWarehouse)[0].totalQty
        },
        revertProduct(){
            this.productForm = {...productForm}
            this.$refs['qty-field'].resetValidation()
        },
        addProduct(){
            let orderItem = {...this.productForm}
            this.orderItems.push(orderItem)
            this.revertProduct()
            this.updateProductArrFromOrderItems()
            this.$refs['product-field'].focus()
        },
        deleteProduct(index){
            this.orderItems.splice(index, 1)
            this.updateProductArrFromOrderItems()
        },
        updateProductArrFromOrderItems(){
            let productIds = this.orderItems.map(i => i.product.id)
            this.productArr = this.allProducts.filter(p => !productIds.includes(p.id))
        },
        async getProductsWithStock(){
            let response = await this.$apollo.query({
                query: GET_ALL_PRODUCTS_IN_ADD_STOCK,
                fetchPolicy: 'network-only'
            })
            if (response.data) {
                this.allProducts = response.data.Products;
                this.productArr = response.data.Products;
            }
            if(this.PRQStock.length) this.insertPRQProductInOrderItems();
        },
        insertPRQProductInOrderItems(){
          /* In future, if multiple products, fetch products by Id then insert into orderItems */
            let product = this.allProducts.find(p => p.id === this.PRQStock[0].productId);
            this.orderItems.push({product, quantity: this.PRQStock[0].quantity});
            this.updateProductArrFromOrderItems()
        },
        async prepareOrderItemsForChangeBranch(orderItems, toWarehouseId){
            this.selectedWarehouse = toWarehouseId
            await this.getProductsWithStock()
            this.orderItems = orderItems.map(i => ({product: this.allProducts.find(p => p.id ===i.productId), quantity:i.neededQty}))
            this.updateProductArrFromOrderItems()
        },
        handleSubmit(){
            let item = this.isSubtract?this.orderItems.find(i => i.quantity > this.productStockByWarehouse(i.product)):undefined
            if(item) {
                this.toaster = {color:'red', enable:true, message: `<b style="font-size: 18px;">Invalid Quantity Entered !</b><br> Please update quantity for product <b style="font-size: 16px">'${item.product.name}'</b>`}
            } else{
                this.saveStock()
            }
        },
        async saveStock () {
            let stockOrderId = Constants.generateUUID()
            let signedValue = (val) => Number(this.isSubtract?(~val + 1):val)

            let response = await this.$apollo.mutate({
                mutation: ADD_STOCK_ORDER,
                variables : {
                    order: {...this.order, id: stockOrderId, toWarehouseId: this.selectedWarehouse},
                    orderItems: this.orderItems.map((i) => ({
                        stockOrderId: stockOrderId,
                        toWarehouseId: this.selectedWarehouse,
                        productId: i.product.id,
                        quantity: signedValue(i.quantity),
                        toQty: { oldStock: this.productStockByWarehouse(i.product), newStock: this.productStockByWarehouse(i.product) + signedValue(i.quantity) },
                        createdBy: user.id,
                        updatedBy: user.id,
                    }))
                }
            })
            if(response.data) this.$emit('saveStock')
        },
        cancel (){
            this.order = {...order}
            this.orderItems = []
            this.revertProduct()
            this.$emit('cancel')
        },
        backToPreviousPopup (){
            this.order = {...order}
            this.orderItems = []
            this.revertProduct()
            this.$emit('back')
        },
    },
    mounted() {
        this.getProductsWithStock()
    }
}
</script>

<style scoped>
    .v-input--selection-controls {
        margin-top: 0;
    }
.operation-div{
    display: inline-flex;
    font-size: 16px;
    font-weight: 600;
    color: #c0c0c0;
    height: 16px;
    margin-top: -20px;
    cursor: pointer;
}
/deep/ .operation-switch.v-input--switch .v-input--switch__track{
    color: #4caf50;
}
/deep/ .operation-switch.v-input--switch .v-input--switch__thumb{
    color: #4caf50;
}
.qty-field{
    width: 120px;
    height: 30px;
    margin: 10px 0 18px 0;
}
/deep/ .qty-field > .v-input__control > .v-input__slot{
    min-height: 10px !important;
}
/deep/ .qty-field > .v-input__control > .v-input__slot> .v-input__prepend-inner> .v-input__icon > .v-icon{
    font-size: 18px;
    padding: 0 16px 4px 0;
}
.delete-item-icon{
    font-size: 18px;
    color: red;
    cursor: pointer;
}
</style>
